import React from 'react';

const AdminComponent = React.lazy(() =>
    import('../components/Admin/AdminPage')
);

const GenerateIdCompoenent = React.lazy(() =>
    import('../components/GenerateId/GenerateId')
);

const SearchIdComponent = React.lazy(() =>
    import('../components/Search/SearchId/SearchId')
);

const HomeComponent = React.lazy(() =>
    import('../components/Home/Home')
);

const Logout = React.lazy(() =>
    import('../components/Auth/Logout/Logout')
);

const AuthComponent = React.lazy(() =>
    import('../components/Auth/Auth')
);

const KitAddComponent = React.lazy(() =>
    import("../components/Admin/ViomeKit/ViomeKitCreate")
);

const KitRemoveComponent = React.lazy(() =>
    import("../components/Admin/ViomeKit/KitRemoveComponent")
);

const ViomeTestCreateComponent = React.lazy(() =>
    import("../components/Admin/ViomeTest/ViomeTestCreate")
)

const ViomeTestUpdateComponent = React.lazy(() => 
    import("../components/Admin/ViomeTest/ViomeTestUpdate")
);

const KitShowAll = React.lazy(() => 
    import("../components/Admin/ViomeKit/ViomeKitShowAll")
);

const ShowGenerateHistory = React.lazy(() =>
    import("../components/User/ShowGenHistory/ShowGenHistory")
);


const routes = [{
    path: '/admin',
    exact: true,
    name: 'Admin',
    component: AdminComponent
},
{
    path: '/admin/kit/create',
    exact: true,
    name: 'AddKit',
    component: KitAddComponent
},
{
    path: '/admin/kit/remove',
    exact: true,
    name: 'RemoveKit',
    component: KitRemoveComponent
},
{
    path: '/admin/kit/show',
    exact: true,
    name: 'ViewAllKits',
    component: KitShowAll
},
{
    path: '/admin/test/create',
    exact: true,
    name: 'CreateTest',
    component: ViomeTestCreateComponent
},
{
    path: '/admin/test/update',
    exact: true,
    name: 'UpdateTest',
    component: ViomeTestUpdateComponent
},
{
    path: '/generate',
    exact: true,
    name: 'GenerateId',
    component: GenerateIdCompoenent
},
{
    path: '/search',
    exact: true,
    name: 'SearchId',
    component: SearchIdComponent
},
{
    path: '/home',
    exact: true,
    name: 'HomePage',
    component: HomeComponent
},
{
    path: '/logout',
    exact: true,
    name: 'HomePage',
    component: Logout
},
{
    path: '/login',
    exact: true,
    name: 'Login',
    component: AuthComponent
},
{
    path: '/genHistory',
    exact: true,
    name: 'GenerateHistory',
    component: ShowGenerateHistory
},
]

export default routes;